export class LoginCommand {
  email: string;
  password: string;
  token: string;
  roles:string;
}
